import Options from './Questions.svelte';

const app = new Options({
	target: document.body
});

export default app;
